import semver from 'semver'

export const checkVersionAndRefresh = (latestVersion: string) => {
  const currentVersion = localStorage.getItem('yld_v')

  if (!currentVersion) {
    return localStorage.setItem('yld_v', latestVersion)
  }

  const shouldRefresh = semver.gt(latestVersion, currentVersion)

  if (shouldRefresh) {
    localStorage.setItem('yld_v', latestVersion)
    window.location.reload()
  }
}
